import styled from 'styled-components';

interface IStatus {
  status: string;
}

export const Container = styled.div`
  button:disabled {
    opacity: 0.5;
    //cursor: not-allowed;
  }
  h3 {
    color: #5d5d5d;
    font-size: 14px;
    font-weight: 400;
  }

  p {
    color: #000;
    font-size: 14px;
    font-weight: 400;
  }

  .w-13 {
    width: 13%;
  }

  .default {
    max-width: 64px;
    max-height: 64px;

    border: solid 1px #002f6c;
    border-radius: 4px;
  }

  .bg-orange {
    background-color: #ff842f;
    padding: 4px 8px;
    height: 32px;
    width: 32px;
    display: inline-block;
  }

  .mkt {
    color: #fff;
    background-color: #ff842f;
    border: none;
    border-radius: 4px;
    padding: 4px 8px;
  }

  button.mkt[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }

  .btn-eye-container {
    width: 32px;
    height: 32px;
  }
`;
